export default "__VITE_ASSET__CLK2vVjZ__"